var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.type === 'item')?_c('v-list-item-title',{style:('white-space: unset !important;'),attrs:{"title":_vm.text},domProps:{"innerHTML":_vm._s(_vm.text)}}):_c('span',{staticClass:"pr-2",class:_vm.compClass},[_vm._v(_vm._s(_vm.text))])
}
var staticRenderFns = []

export { render, staticRenderFns }